import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, Navigate } from "react-router-dom";
import { Button, Space } from "antd";

import { UnsubscribeConfirmation } from "./UnsubscribePage";

const ALLOWED_HOSTS = ["localhost", "127.0.0.1", "my.nextgis.dev"];
const mockUnsubscribe = async () => {
  await new Promise<void>((resolve) => window.setTimeout(resolve, 700));
};

export const TestUnsubscribePage = () => {
  const { t } = useTranslation();
  const [preview, setPreview] = useState(0);

  if (!ALLOWED_HOSTS.includes(window.location.hostname)) {
    return <Navigate to="/" replace />;
  }

  return (
    <>
      <div style={{ padding: 16, textAlign: "center" }}>
        <p>{t("mailing.previewDescription")}</p>
        <Space>
          <Link to="/test">{t("app.goBack")}</Link>
          <Button onClick={() => setPreview((value) => value + 1)}>
            {t("mailing.previewReset")}
          </Button>
        </Space>
      </div>
      <UnsubscribeConfirmation
        key={preview}
        hash="preview"
        onUnsubscribe={mockUnsubscribe}
      />
    </>
  );
};
